/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:44:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-28 08:30:00
 */
export default [
  {
    path: '/',
    name: 'Datav',
    component: () => import('@/components/datav/index.vue'),
    meta: {
      title: '数据大屏',
    },
  },
]
